<template>
  <div id="navbar-logo" class="navbar-logo">
    <a
      id="kariermu-logo-wrapper"
      :class="{ 'disabled-link': isPrakerjaFaceRecognitionPath }"
      :href="logoUrl"
      @click="!isPrakerja && logEventAnalytics('prakerja_kariermu_logo_click')"
    >
      <img
        id="kariermu-logo"
        src="https://cdn.karier.mu/kariermu/assets/logo/kariermu-2023.webp"
        alt="karier.mu"
      >
    </a>
    <template v-if="isPrakerja">
      <div class="menu-divider"></div>
      <a
        href="https://www.prakerja.go.id/"
        :class="{ 'disabled-link': isPrakerjaFaceRecognitionPath }"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          id="prakerja-logo"
          class="prakerja-logo"
          src="https://cdn.karier.mu/kariermu/assets/logo/prakerja-2023.webp"
          alt="Prakerja"
          @click="logEventAnalytics('prakerja_kartu_logo_click')"
        >
      </a>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import deviceDetector from 'mobile-device-detect'
import platinumMixin from '@/mixins/platinumMixin'

export default {
  name: 'NavbarLogo',
  mixins: [platinumMixin],
  data () {
    return {
      isMobile: deviceDetector.isMobile
    }
  },
  computed: {
    ...mapState('user', ['isLogin', 'userInfo']),
    isPrakerjaFaceRecognitionPath () {
      return this.$route.path.includes('prakerja-face-recognition-status') || this.$route.path.includes('fr-dummy-redirect')
    }
  },
  methods: {
    logEventAnalytics (eventName) {
      if (this.isLogin) {
        window.firebaseAnalytics.logEvent(eventName, {
          screen_url: window.location.href,
          user_profession: this.userInfo.profession_name,
          user_year_level: this.userInfo.year_level_name,
          user_is_admin: this.userInfo.is_admin,
          user_id: this.userInfo.id,
          source: this.isMobile ? 'mobile-web' : 'web'
        })
      }
    }
  }
}
</script>

<style scoped>
.navbar-logo{
  display: flex;
  align-items: center;
  gap: 8px;
}

.disabled-link {
  pointer-events: none;
}

.navbar-wrapper {
  display: flex;
  align-items: center;
}

#kariermu-logo {
  width: 93.05px;
  height: 19.46px;
  object-fit: contain;
}

.menu-divider {
  border-left: 1px solid var(--color-neutral-500);
  height: 24px;
}

.prakerja-logo {
  width: 67.14px;
  height: 19.46px;
  object-fit: contain;
}

@media screen and (min-width: 1024px) {
  #kariermu-logo {
    width: 138.48px;
    height: 24px;
  }

  .prakerja-logo {
    width: 97px;
    height: 28px;
  }
}
</style>
